import {createRootRoute, Outlet} from '@tanstack/react-router';
import {onlineManager} from '@tanstack/react-query';
import {useEffect} from 'react';
import {useConnectivityStore} from '@/lib/offline/connectivity';
import {initOffline} from '@/lib/offline/init';
import {useAuth} from '@/hooks/useAuth';
import {ConsentBanner} from '@/components/ConsentBanner';
import {UpdatePrompt} from '@/components/UpdatePrompt';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const {user} = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    const cleanupOffline = initOffline(user.id);

    onlineManager.setOnline(useConnectivityStore.getState().isOnline);
    const unsubscribeOnlineManager = useConnectivityStore.subscribe((state) => {
      onlineManager.setOnline(state.isOnline);
    });

    return () => {
      cleanupOffline();
      unsubscribeOnlineManager();
    };
  }, [user?.id]);

  return (
    <>
      <Outlet />
      <ConsentBanner />
      <UpdatePrompt />
    </>
  );
}
